/* eslint-disable filenames/match-exported */
// ^ This component is a subcomponent so it uses a `SelectMenu.Subcomponent` filename
import React from 'react';
import PropTypes from 'prop-types';
import SearchInput from './SearchInput';
import './SelectMenu.Filter.scss';
var SelectMenuFilter = function (_a) {
    var onChange = _a.onChange, value = _a.value;
    return (React.createElement("div", { className: 'SelectMenuFilter' },
        React.createElement(SearchInput, { className: 'SelectMenuFilter__input', onChange: onChange, onClear: function () { return onChange(''); }, shouldAutoFocus: true, size: 'small', value: value })));
};
SelectMenuFilter.defaultProps = {
    value: ''
};
SelectMenuFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
};
export default SelectMenuFilter;
//# sourceMappingURL=SelectMenu.Filter.js.map